export const tabs = async () => {
  type TabElement = HTMLElement
  type TabPanelElement = HTMLElement

  type TabsAutomaticProps = {
    groupNode: HTMLElement
  }

  const TabsAutomatic = ({ groupNode }: TabsAutomaticProps): void => {
    const tabs: TabElement[] = Array.from(
      groupNode.querySelectorAll("[role=tab]")
    )
    const tabpanels: TabPanelElement[] = tabs.map(
      (tab) =>
        document.getElementById(
          tab.getAttribute("aria-controls") || ""
        ) as TabPanelElement
    )

    const firstTab: TabElement | null = tabs[0] || null
    const lastTab: TabElement | null = tabs[tabs.length - 1] || null

    const setSelectedTab = (
      currentTab: TabElement,
      setFocus: boolean = true
    ): void => {
      tabs.forEach((tab, index) => {
        if (currentTab === tab) {
          tab.setAttribute("aria-selected", "true")
          tab.removeAttribute("tabindex")
          tabpanels[index]?.classList.remove("is-hidden")
          if (setFocus) tab.focus()
        } else {
          tab.setAttribute("aria-selected", "false")
          tab.tabIndex = -1
          tabpanels[index]?.classList.add("is-hidden")
        }
      })
    }

    const setSelectedToPreviousTab = (currentTab: TabElement): void => {
      if (currentTab === firstTab) {
        lastTab && setSelectedTab(lastTab)
      } else {
        const index = tabs.indexOf(currentTab)
        setSelectedTab(tabs[index - 1])
      }
    }

    const setSelectedToNextTab = (currentTab: TabElement): void => {
      if (currentTab === lastTab) {
        firstTab && setSelectedTab(firstTab)
      } else {
        const index = tabs.indexOf(currentTab)
        setSelectedTab(tabs[index + 1])
      }
    }

    const onKeydown = (event: KeyboardEvent): void => {
      const target = event.currentTarget as TabElement
      let flag = false

      switch (event.key) {
        case "ArrowLeft":
          setSelectedToPreviousTab(target)
          flag = true
          break
        case "ArrowRight":
          setSelectedToNextTab(target)
          flag = true
          break
        case "Home":
          firstTab && setSelectedTab(firstTab)
          flag = true
          break
        case "End":
          lastTab && setSelectedTab(lastTab)
          flag = true
          break
        default:
          break
      }

      if (flag) {
        event.stopPropagation()
        event.preventDefault()
      }
    }

    const onClick = (event: MouseEvent): void => {
      setSelectedTab(event.currentTarget as TabElement)
    }

    tabs.forEach((tab) => {
      tab.tabIndex = -1
      tab.setAttribute("aria-selected", "false")
      tab.addEventListener("keydown", onKeydown)
      tab.addEventListener("click", onClick)
    })

    if (firstTab) {
      setSelectedTab(firstTab, false)
    }
  }

  window.addEventListener("load", () => {
    const tablists = document.querySelectorAll("[role=tablist].automatic")
    tablists.forEach((tablist) => {
      TabsAutomatic({ groupNode: tablist as HTMLElement })
    })
  })
}
